import { render, staticRenderFns } from "./comfirm.vue?vue&type=template&id=cfc2f5a2&scoped=true&"
import script from "./comfirm.vue?vue&type=script&lang=js&"
export * from "./comfirm.vue?vue&type=script&lang=js&"
import style0 from "./comfirm.vue?vue&type=style&index=0&id=cfc2f5a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc2f5a2",
  null
  
)

export default component.exports